import { useEffect, useState } from 'react';

const OLD_KEYS = ['sidebar-collapsed', 'nav:sidebarCollapsed', 'nura_nav_collapsed'];
const NEW_KEY = 'nura.nav.sidebarCollapsed:v1';

const safeWindow = () => (typeof window !== 'undefined' ? window : undefined);

const migrateOnce = () => {
  const w = safeWindow();
  if (!w) return;
  try {
    const hasNew = w.localStorage.getItem(NEW_KEY);
    if (hasNew != null) return;
    for (const k of OLD_KEYS) {
      const v = w.localStorage.getItem(k);
      if (v != null) {
        w.localStorage.setItem(NEW_KEY, v === 'true' ? 'true' : 'false');
        // clean old keys
        try { w.localStorage.removeItem(k); } catch { /* noop */ }
      }
    }
  } catch {
    // noop
  }
};

export const readCollapsed = (): boolean => {
  const w = safeWindow();
  if (!w) return false;
  migrateOnce();
  try {
    return w.localStorage.getItem(NEW_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeCollapsed = (collapsed: boolean) => {
  const w = safeWindow();
  if (!w) return;
  try {
    w.localStorage.setItem(NEW_KEY, collapsed ? 'true' : 'false');
  } catch {
    // noop
  }
};

export const useSidebarCollapsed = () => {
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => {
    setCollapsed(readCollapsed());
  }, []);
  const update = (v: boolean) => {
    setCollapsed(v);
    writeCollapsed(v);
  };
  return [collapsed, update] as const;
};

export const __keys = { OLD_KEYS, NEW_KEY };
